// extracted by mini-css-extract-plugin
export default {"frameUser":"FrameUser_frameUser__cTeSW"};